module.exports = __webpack_public_path__ + "static/media/BG_PDJ_EventOrgs.3e60ba6e.jpg";